export default ({ request }) => ({
  billStockInDetailReportListApi(data = {}) {
    return request({
      url: '/samplemanage/bill/stockIn/detail/reportList',
      method: 'post',
      data,
    })
  },
})
